/* ==========================================================================
   Satjeevan — Comparison Table CTA (product-comparison-table.js)

   The design reference's "See What Makes It Different" button scrolls the
   page to the buy box. This theme's real Add to Cart form always carries
   `data-type="add-to-cart-form"` (see snippets/product-fbt-card.liquid,
   snippets/sj-bestsellers-card.liquid) so that selector is tried first;
   a couple of generic fallbacks are tried after it, and the click is a
   no-op if none are found (e.g. Theme Editor preview without a product
   context) rather than throwing.
   ========================================================================== */

(function () {
  'use strict';

  var INIT_ATTR = 'data-sj-cmp-cta-init';

  function findBuyBox() {
    return (
      document.querySelector('[data-type="add-to-cart-form"]') ||
      document.querySelector('product-form-component') ||
      document.querySelector('form[action*="/cart/add"]')
    );
  }

  function init() {
    var buttons = document.querySelectorAll('[data-sj-cmp-cta]:not([' + INIT_ATTR + '])');

    buttons.forEach(function (button) {
      button.setAttribute(INIT_ATTR, '1');

      button.addEventListener('click', function () {
        var target = findBuyBox();
        if (!target) return;
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Shopify Theme Editor live-reload support
  document.addEventListener('shopify:section:load', init);
})();
